<template>
  <div
    class="h-screen flex w-full vx-row items-center justify-center"
    id="page-login"
  >
    <div class="vx-col">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-col d-theme-dark-bg">
            <div class="p-8 login-tabs-container">
              <div class="vx-card__title mb-4">
                <center class="mb-4">
                  <img src="@/assets/images/logo/logo.png" alt="logo" />
                </center>
                <p>Connectez-vous pour commencer une session</p>
              </div>

              <div>
                <vs-input
                  @keyup.enter="login()"
                  :danger="error.phone ? true : false"
                  :danger-text="error.phone ? error.phone[0] : ''"
                  autocomplete="off"
                  name="phone"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  label-placeholder="Adresse email"
                  v-model="form.phone"
                  class="w-full"
                />

                <vs-input
                  @keyup.enter="login()"
                  :danger="error.password ? true : false"
                  :danger-text="error.password ? error.password[0] : ''"
                  autocomplete="off"
                  type="password"
                  name="password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Mot de passe"
                  v-model="form.password"
                  class="w-full mt-6"
                />

                <div class="flex flex-wrap justify-between my-5">
                  <!--<router-link to="">Mot de passe oublié ?</router-link>-->
                </div>
                <vs-button @click="login()" class="float-right"
                  >Connexion</vs-button
                >
                <br />
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: [],
      form: {
        phone: "",
        password: "",
      },
    };
  },
  methods: {
    login() {
      this.$vs.loading();
      window.GETCCMT.$http
        .post("/login", this.form)
        .then((response) => {
          if (response.data.status) {
            this.error = [];
            if (response.data.auth === "OTP") {
              window.LoginCCMT.phone = response.data.phone;
              window.LoginCCMT.phone_see = !window.LoginCCMT.phone_see;
              window.LoginCCMT.sms = !window.LoginCCMT.sms;
              window.LoginCCMT.code = response.data.code;
              window.GETCCMT.success("Connexion avec succès", response);

              this.$vs.loading.close();
            } else {
              response.data.user.displayName = response.data.user.name;
              response.data.user.userRole = response.data.user.profile;
              response.data.user.company = response.data.user.customer;
              response.data.user.photoURL = response.data.user.photo;
              this.$store.dispatch("updateUserInfo", response.data.user);

              this.$vs.loading.close();
              this.$router.push("/dashboard");
            }
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            window.GETCCMT.$router.push("/login");
          } else {
            this.error = error.response.data.errors;
          }
        });
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
</style>
